// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2gY6S","colMaxWidth":"Table_colMaxWidth__QkPwT"};